import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_person",
  "use": "svg_person-usage",
  "viewBox": "0 0 17 19",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 19\" id=\"svg_person\"><circle cx=\"8.5\" cy=\"5.5\" r=\"5\" stroke=\"currentColor\" /><path d=\"M16 18.5v0A7.5 7.5 0 0 0 8.5 11v0A7.5 7.5 0 0 0 1 18.5v0\" stroke=\"currentColor\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol